import { Card, Col, Row } from "react-bootstrap";
import { UserEditForm } from "@/components/entities/user/UserEditForm";
import { ButtonLinkBack } from "@/components/lib/ButtonLinkBack";

export const UserEdit = () => {
  /* Render
   *******************************************************************************************/
  return (
    <>
      <Row>
        <Col>
          <ButtonLinkBack />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col className="col-xl-6 col-lg-10 col-md-12 mx-auto">
          <Card className="mb-4">
            <Card.Header>
              <h5 className="mt-2">
                Modifier les informations de l'utilisateur
              </h5>
            </Card.Header>
            <Card.Body className="p-5">
              <UserEditForm />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};
